import { SelectOption } from '@umss/shared/ui';
import { ContractorDocumentType } from './contractor-document.model';

/**
 * Options for document types available for profile uploading
 */
export const DOCUMENT_TYPE_OPTIONS: SelectOption[] = [
  {
    label: 'Background check',
    value: ContractorDocumentType.BACKGROUND_CHECK
  },
  {
    label: 'Contractor agreement',
    value: ContractorDocumentType.CONTRACTOR_AGREEMENT
  },
  {
    label: 'Immunization records',
    value: ContractorDocumentType.IMMUNIZATION_RECORDS
  },
  {
    label: 'Driver license',
    value: ContractorDocumentType.DRIVERS_LICENSE
  },
  {
    label: 'Photo ID',
    value: ContractorDocumentType.PHOTO_ID
  }
];

export const DOCUMENT_FORMS: SelectOption[] = [
  {
    label: 'Direct deposit form',
    value: ContractorDocumentType.DIRECT_DEPOSIT_FORM
  },
  {
    label: 'W9 form',
    value: ContractorDocumentType.W9_FORM
  },
  {
    label: 'I9 form',
    value: ContractorDocumentType.I9_FORM
  }
];

/**
 * Options for certification types available for profile uploading
 */
export const CERTIFICATION_TYPE_OPTIONS: SelectOption[] = [
  {
    label: 'BLS certification',
    value: ContractorDocumentType.BLS_CERTIFICATION
  },
  {
    label: 'CPR certification',
    value: ContractorDocumentType.CPR_CERTIFICATION
  },
  {
    label: 'Other certification',
    value: ContractorDocumentType.OTHER_CERTIFICATION
  },
  {
    label: 'Medical license',
    value: ContractorDocumentType.MEDICAL_LICENSE
  }
];

/**
 * Defines the category configuration required by the document list
 */
export type DocumentListCategory = 'certifications' | 'documents' | 'forms';
